
import {FBColumnOptions} from "./FBColumn.Options";
import {FBRowOptions} from "FormBuilder/Core/FBRow.Options";

import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {ContainerDataRetriever, FormBuilderModel} from "FormBuilder/Core/FormBuilder.Model";
import {ModelWithParent} from "FormBuilder/Core/Models/ModelWithParenth";
import {FormBuilderOptions} from "FormBuilder/Core/FormBuilder.options";
import {ModelSerialize} from "FormBuilder/Core/Models/ModelBase";


export class FBRowModel extends ModelWithParent<FBRowOptions,ContainerDataRetriever> {
    @ModelSerialize()
    public Columns:FBColumnModel[];
    public Instance:HTMLDivElement;

    constructor(Options: FBRowOptions, Parent: ContainerDataRetriever,previousData:any=null) {
        super(Options, Parent);
        this.Columns=[];
        for(let column of this.Options.Columns)
            this.Columns.push(new FBColumnModel(column,this,previousData));
    }


    public get FormBuilder():ContainerDataRetriever{
        return this.Parent;
    }
}